import React from 'react';
import styles from '../../assets/css/module/common.module.css';

const PageError404 = () => {  
  return (
    <div className={`${styles['default-layout']}`}>
      <h1>404</h1>
    </div>
  );
}

export default PageError404;